var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065",
    transform: "translate(-75.5 -325.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M90,196v4a1,1,0,0,0,1,1h4",
    transform: "translate(-5 130)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7464",
    "data-name": "Path 7464",
    d: "M93,214H83a2,2,0,0,1-2-2V198a2,2,0,0,1,2-2h7l5,5v11a2,2,0,0,1-2,2Z",
    transform: "translate(-5 130)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7465",
    "data-name": "Path 7465",
    d: "M85,200h1",
    transform: "translate(-5 130)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7466",
    "data-name": "Path 7466",
    d: "M85,206h6",
    transform: "translate(-5 130)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7467",
    "data-name": "Path 7467",
    d: "M89,210h2",
    transform: "translate(-5 130)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMenu);
export default __webpack_public_path__ + "static/media/quote-menu.866b9e6b3a1184a51b27536f640a5fb7.svg";
export { ForwardRef as ReactComponent };